import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";

export default function simulatiePerInfrastructuurReducer(state = initialState.simulatiePerInfrastructuurModal, action) {
	switch (action.type) {
		case types.SIMULATIE_PER_INFRASTRUCTUUR_CACHE_SAVED: {
			let stateToUpdate = mergeDeep({}, state);

			if (stateToUpdate.item != null) {
				let items = stateToUpdate.item.sportinfrastructurenOpKaart;
				let newItems = [...items.filter(x => x.id != action.body.item.id), action.body.item];

				stateToUpdate.item.sportinfrastructurenInDeBuurt = newItems;
				stateToUpdate.item.sportinfrastructurenOpKaart = newItems;
			}
			stateToUpdate.documenten = action.body.documenten;
			stateToUpdate.isSaved = action.body.isSaved;
			stateToUpdate.fileSessionStarted = action.body.fileSessionStarted;

			return stateToUpdate;
		}

		case types.SIMULATIE_PER_INFRASTRUCTUUR_VALIDATED: {
			return Object.assign({}, state,
				{
					infrastructuurInDeBuurtErrors: action.body.errors
				});
		}

		default:
			return state;
	}
}